/**
 * The Game tab's body: the Survivor pick surface itself (ISSUE-973), matching
 * the legacy Survivor Game tab. The sheet it used to open is no longer
 * mounted here.
 */
import type { ReactNode } from "react";

import { PoolCorrectionReviews } from "../contestConfirm/ContestCorrectionReview";
import { PoolHomeConfirmGate } from "../contestConfirm/PoolHomeConfirmGate";
import type { typePoolRole } from "../poolHome/poolHomeState";
import { SurvivorGameTab } from "../survivorGame/SurvivorGameTab";
import { poolTypePanes } from "./poolTypePanes";

export type typePoolGameTabPaneProps = {
  poolId: string;
  contestId?: string | undefined;
  /** The Commissioner and Admins only (ISSUE-1042 R4). */
  onStartContest?: (() => void) | undefined;
  /** ISSUE-1334. Null or "survivor" mounts the Survivor pick surface. */
  contestType?: string | null | undefined;
  viewerPoolRole?: typePoolRole | undefined;
  /**
   * The Commissioner and Admins (ISSUE-1325). Presentation only: it spares a
   * plain member a read the server would refuse with FORBIDDEN_ROLE.
   */
  canManage?: boolean | undefined;
};

export const PoolGameTabPane = ({
  poolId,
  contestId,
  onStartContest,
  contestType = null,
  viewerPoolRole = "member",
  canManage = false,
}: typePoolGameTabPaneProps): ReactNode => {
  const panes = poolTypePanes(contestType);
  if (panes !== null) {
    // ISSUE-1309. Every pick'em contest ends in pendingOutcome, so the
    // Commissioner's confirm and tie naming have to live on its Game tab too,
    // the screen the day-6 nudge opens. The gate renders nothing for a plain
    // member (the server refuses their read) and nothing with no outcome.
    return (
      <div className="flex flex-col gap-3" data-testid="pool-game-tab">
        {contestType === "pickem" ? (
          <div data-testid="pool-game-status-slot">
            <PoolHomeConfirmGate poolId={poolId} />
          </div>
        ) : null}
        <panes.GameTab poolId={poolId} viewerPoolRole={viewerPoolRole} />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-3" data-testid="pool-game-tab">
      <div className="flex flex-col gap-3" data-testid="pool-game-status-slot">
        <PoolHomeConfirmGate poolId={poolId} contestId={contestId} />
        {canManage ? <PoolCorrectionReviews poolId={poolId} /> : null}
      </div>
      <SurvivorGameTab
        poolId={poolId}
        contestId={contestId}
        onStartContest={onStartContest}
      />
    </div>
  );
};
